import { render, staticRenderFns } from "./FlexAlignSelf.vue?vue&type=template&id=424b6a8d&"
import script from "./FlexAlignSelf.vue?vue&type=script&lang=js&"
export * from "./FlexAlignSelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports